var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcStartCopyArrow = function SvgIcStartCopyArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.212 13.198c.404.432.38 1.11-.052 1.514l-5.357 5a1.071 1.071 0 0 1-1.463 0l-5.357-5a1.071 1.071 0 1 1 1.462-1.566l4.626 4.317 4.627-4.317a1.071 1.071 0 0 1 1.514.052Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.212 6.34c.404.433.38 1.11-.052 1.515l-5.357 5a1.071 1.071 0 0 1-1.463 0l-5.357-5a1.071 1.071 0 1 1 1.462-1.567l4.626 4.318 4.627-4.318a1.071 1.071 0 0 1 1.514.052Z"
  })));
};
export default SvgIcStartCopyArrow;